var React = require('react');

function VectotSubmenuClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.65 0L10 7.417L2.35 0L0 2.2834L10 12L20 2.2834L17.65 0Z","fill":"#8A898C"}));
}

VectotSubmenuClose.defaultProps = {"width":"20","height":"12","viewBox":"0 0 20 12","fill":"none"};

module.exports = VectotSubmenuClose;

VectotSubmenuClose.default = VectotSubmenuClose;
